import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';

import Nav from './components/Nav';
import Footer from './components/Footer';
import DisclaimerStrip from './components/DisclaimerStrip';

import Home from './pages/Home';
import Activities from './pages/Activities';
import HowItWorks from './pages/HowItWorks';
import AboutHub from './pages/AboutHub';
import MindfulPlay from './pages/MindfulPlay';
import ReachUs from './pages/ReachUs';
import HubTerms from './pages/HubTerms';
import Privacy from './pages/Privacy';
import CookieNotice from './pages/CookieNotice';
import NotFound from './pages/NotFound';

// Compass Read game
import CompassRead from './games/CompassRead';
import RouteBuilder from './games/RouteBuilder';
import AltitudeGauge from './games/AltitudeGauge';

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <DisclaimerStrip />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/activities/compass-read" element={<CompassRead />} />
          <Route path="/activities/route-builder" element={<RouteBuilder />} />
          <Route path="/activities/altitude-gauge" element={<AltitudeGauge />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about-hub" element={<AboutHub />} />
          <Route path="/mindful-play" element={<MindfulPlay />} />
          <Route path="/reach-us" element={<ReachUs />} />
          <Route path="/hub-terms" element={<HubTerms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-notice" element={<CookieNotice />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
